import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { change_Lang } from "../../../actions/Helper_action";
import { Eye, Search, Trash } from "react-feather";
import Time from "react-time-format";
import { Get_List_Required_Property } from "../../../actions/Property_action";
import Swal from "sweetalert2";
import { Input, Select } from "antd";
import { isMobile } from "react-device-detect";

const AllSellRequired = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_Required_Property());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const list_of_required_property = useSelector(
    (state) => state.PropertyReducer.list_of_required_property
  );
  const require_status = useSelector(
    (state) => state.PropertyReducer.require_status
  );
  const [search, setsearch] = useState("");
  const [select_type_property, setselect_type_property] = useState("");
  const [select_status_property, setselect_status_property] = useState("");
  const handleChange_StatusProperty = (value) => {
    setselect_status_property(value);
  };
  const handleChange_SelectProperty = (value) => {
    setselect_type_property(value);
  };
  const datas = list_of_required_property
    .filter((data) => {
      if (data.status !== "delete") {
        if (isNaN(search)) {
          if (
            data.agentId &&
            data.agentId.fname.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.agentId &&
              data.agentId.fname.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (
            dispatch(change_Lang(data.Type_property))
              .toLowerCase()
              .startsWith(search.toLowerCase())
          ) {
            return dispatch(change_Lang(data.Type_property))
              .toLowerCase()
              .startsWith(search.toLowerCase());
          } else if (data.status === "sold") {
            return data.status === "sold";
          }
        } else if (select_type_property === "Apartment") {
          return data.Property && data.Property === "Apartment";
        } else if (select_type_property === "House") {
          return data.Property && data.Property === "House";
        } else if (select_type_property === "Farm") {
          return data.Property && data.Property === "Farm";
        } else if (select_type_property === "Shop") {
          return data.Property && data.Property === "Shop";
        } else if (select_type_property === "Vella") {
          return data.Property && data.Property === "Vella";
        } else if (select_type_property === "Earth") {
          return data.Property && data.Property === "Earth";
        } else if (select_type_property === "The gas station") {
          return data.Property && data.Property === "The gas station";
        } else if (select_type_property === "Factory") {
          return data.Property && data.Property === "Factory";
        } else if (select_type_property === "GYM") {
          return data.Property && data.Property === "GYM";
        } else if (select_type_property === "store") {
          return data.Property && data.Property === "store";
        } else if (select_type_property === "Restaurant") {
          return data.Property && data.Property === "Restaurant";
        } else if (select_type_property === "Commercial Land") {
          return data.Property && data.Property === "Commercial Land";
        } else if (select_type_property === "Company") {
          return data.Property && data.Property === "Company";
        } else if (select_type_property === "Hotel") {
          return data.Property && data.Property === "Hotel";
        } else if (select_type_property === "Car Garage") {
          return data.Property && data.Property === "Car Garage";
        } else if (select_type_property === "Stadium") {
          return data.Property && data.Property === "Stadium";
        } else if (select_type_property === "Car wash") {
          return data.Property && data.Property === "Car wash";
        } else if (select_type_property === "Building") {
          return data.Property && data.Property === "Building";
        } else if (select_type_property === "Agitator") {
          return data.Property && data.Property === "Agitator";
        } else if (select_type_property === "residential community") {
          return data.Property && data.Property === "residential community";
        } else if (
          select_type_property === "agricultural land of the register"
        ) {
          return (
            data.Property &&
            data.Property === "agricultural land of the register"
          );
        } else if (select_type_property === "unregistered agricultural land") {
          return (
            data.Property && data.Property === "unregistered agricultural land"
          );
        } else if (select_type_property === "Government agricultural land") {
          return (
            data.Property && data.Property === "Government agricultural land"
          );
        } else if (select_type_property === "Land of Istamar") {
          return data.Property && data.Property === "Land of Istamar";
        } else if (select_type_property === "Erth Musataha") {
          return data.Property && data.Property === "Erth Musataha";
        } else if (select_type_property === "school") {
          return data.Property && data.Property === "school";
        } else if (select_type_property === "Building of Istamar") {
          return data.Property && data.Property === "Building of Istamar";
        } else if (select_type_property === "Building of Musataha") {
          return data.Property && data.Property === "Building of Musataha";
        } else if (select_status_property === "deactive") {
          return data.status === "deactive";
        } else if (select_status_property === "active") {
          return data.status === "active";
        } else {
          return data.Phone && data.Phone.toString().startsWith(search);
        }
      }
    })
    .map((el, i) => {
      return {
        id: i + 1,
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
          />
        ),
        Buyer_name: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Buyer_name}
          </span>
        ),
        agent: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{`${
            el.agentId && el.agentId.fname
          } ${el.agentId && el.agentId.lname}`}</span>
        ),
        Place_en: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {lang === "en"
              ? el.Place_en
              : lang === "krd"
              ? el.Place_ku
              : el.Place_ar}
          </span>
        ),
        Area: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.Area}&nbsp;م<sup>2</sup>
          </span>
        ),
        phone: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.Phone}</span>
        ),
        Type_of_property: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {dispatch(change_Lang(el.Property))}
          </span>
        ),
        Type_property: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {dispatch(change_Lang(el.Type_property))}
          </span>
        ),
        Typr_Buy: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {dispatch(change_Lang(el.Typr_Buy))}
          </span>
        ),
        status:
          el.status === "active" ? (
            <label
              className={`${lang === "en" ? "px-4" : "fk px-4 "}`}
              style={{
                color: "green",
                background: "#efefed",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : el.status === "deactive" ? (
            <label
              className={`${lang === "en" ? "px-4" : "fk px-4"}`}
              style={{
                color: "red",
                background: "#efefed",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : el.status === "sold" ? (
            <label
              className={`${lang === "en" ? "px-4" : "fk px-3"}`}
              style={{
                color: "white",
                background: "#d9534f",
                borderRadius: "5px",
                fontSize: "14px",
              }}
            >
              {dispatch(change_Lang(el.status))}
            </label>
          ) : (
            ""
          ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("d_productname")),
      selector: "Buyer_name",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("profile_mob")),
      selector: "phone",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("property_just")),
      selector: "Type_property",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Type of property")),
      selector: "Type_of_property",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("profile_location")),
      selector: "Place_en",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Area")),
      selector: "Area",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("d_status")),
      selector: "status",
      center: true,
      compact: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const { Option } = Select;
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("ListReuiredProperty"))}
          parent={dispatch(change_Lang("ListReuiredProperty"))}
        />
        {require_status !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div className={isMobile ? "" : "card"}>
                    <div className="row ">
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-2"></div>
                          <div
                            className={
                              isMobile
                                ? "col-md-5 mt-4 d-flex justify-content-center"
                                : "col-md-5 mt-4 d-flex justify-content-start"
                            }
                          >
                            <Select
                              value={select_type_property}
                              onChange={handleChange_SelectProperty}
                              defaultValue={dispatch(change_Lang("Choose"))}
                              className="fk text-center mt-2"
                              size="middle"
                              showSearch
                              optionFilterProp="children"
                              filterOption={true}
                              style={{
                                fontSize: "16px",
                                borderBottomColor: "#052f43",
                                width: "200px",
                              }}
                              showArrow={false}
                            >
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value=""
                              >
                                {dispatch(change_Lang("Choose"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Apartment"
                              >
                                {dispatch(change_Lang("Apartment"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="House"
                              >
                                {dispatch(change_Lang("House"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Farm"
                              >
                                {dispatch(change_Lang("Farm"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Shop"
                              >
                                {dispatch(change_Lang("Shop"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Vella"
                              >
                                {dispatch(change_Lang("Vella"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Earth"
                              >
                                {dispatch(change_Lang("Earth"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Commercial Land"
                              >
                                {dispatch(change_Lang("Commercial Land"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Company"
                              >
                                {dispatch(change_Lang("Company"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Hotel"
                              >
                                {dispatch(change_Lang("Hotel"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Car Garage"
                              >
                                {dispatch(change_Lang("Car Garage"))}
                              </Option>
                              <Option
                                className="fk"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                                value="Stadium"
                              >
                                {dispatch(change_Lang("Stadium"))}
                              </Option>
                              <Option
                                value={"Car wash"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Car wash"))}
                              </Option>
                              <Option
                                value={"The gas station"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("The gas station"))}
                              </Option>
                              <Option
                                value={"Factory"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Factory"))}
                              </Option>
                              <Option
                                value={"GYM"}
                                className="fk"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("GYM"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"palace"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("palace"))}
                              </Option>
                              <Option
                                value={"store"}
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("store"))}
                              </Option>
                              <Option
                                value={"Restaurant"}
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {dispatch(change_Lang("Restaurant"))}
                              </Option>
                              {/* new one */}
                              <Option
                                className="fk"
                                value={"Building"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Agitator"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Agitator"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"residential community"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("residential community"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"agricultural land of the register"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang(
                                    "agricultural land of the register"
                                  )
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"unregistered agricultural land"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang("unregistered agricultural land")
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"Government agricultural land"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(
                                  change_Lang("Government agricultural land")
                                )}
                              </Option>
                              <Option
                                className="fk"
                                value={"Land of Istamar"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Land of Istamar"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Erth Musataha"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Erth Musataha"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"school"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("school"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Building of Istamar"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building of Istamar"))}
                              </Option>
                              <Option
                                className="fk"
                                value={"Building of Musataha"}
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                }}
                              >
                                {dispatch(change_Lang("Building of Musataha"))}
                              </Option>
                            </Select>
                          </div>
                          <div
                            className={
                              isMobile
                                ? "col-md-5 mt-4 d-flex justify-content-center"
                                : "col-md-5 mt-4 d-flex justify-content-start"
                            }
                          >
                            <Select
                              value={select_status_property}
                              onChange={handleChange_StatusProperty}
                              defaultValue={dispatch(change_Lang("d_status"))}
                              className="fk text-center mt-2"
                              size="middle"
                              showSearch
                              optionFilterProp="children"
                              filterOption={true}
                              style={{
                                fontSize: "16px",
                                borderBottomColor: "#052f43",
                                width: "200px",
                              }}
                              showArrow={false}
                            >
                              <Option className="fk" value={""}>
                                {dispatch(change_Lang("d_status"))}
                              </Option>
                              <Option
                                style={{ color: "green" }}
                                value="active"
                                className="fk"
                              >
                                {dispatch(change_Lang("active"))}
                              </Option>
                              <Option
                                value="deactive"
                                style={{ color: "red" }}
                                className="fk"
                              >
                                {dispatch(change_Lang("deactive"))}
                              </Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          isMobile ? "col-md-5" : "col-md-5 card-header"
                        }
                      >
                        <div
                          className=" text-center mt-2"
                          style={{ background: "" }}
                        >
                          <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                            {dispatch(change_Lang("ListReuiredProperty"))}
                          </h3>
                        </div>
                      </div>
                      <div
                        className="col-md-3 m-auto"
                        style={{ background: "" }}
                      >
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="mt-2 ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        data={datas}
                        pagination={true}
                        striped
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Fragment>
    </>
  );
};

export default AllSellRequired;
